export function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full">
        <iframe
          src="https://player.vimeo.com/video/650431526?h=f40be620b2&autoplay=1&loop=1&autopause=0&muted=1&title=0&byline=0&portrait=0&controls=0"
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            width: '100vw',
            height: '100vh',
            transform: 'scale(1.1)', // Slightly scale up to avoid borders
          }}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center text-white">
        {/* Main Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8">
          Welcome to Goodspeed Airport and
          <br />
          Seaplane Base
        </h1>
        
        {/* Phone Number */}
        <div className="absolute bottom-16">
          <a 
            href="tel:8606159068"
            className="text-xl md:text-2xl font-semibold hover:text-blue-300 transition-colors"
          >
            860-615-9068
          </a>
        </div>
      </div>
    </section>
  );
}